import React from 'react';
import { Group, Text, Button, Stack, Box } from '@mantine/core';
import { Check, Clock, AlertTriangle, Upload, CreditCard } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import type { Payment } from '../types';
interface PaymentItemProps {
  payment: Payment;
  onUploadProof?: () => void;
  onPayNow?: () => void;
}
const statusIcons = {
  paid: Check,
  upcoming: Clock,
  overdue: AlertTriangle
};
const statusColors = {
  paid: '#10b981',
  upcoming: '#64748b',
  overdue: '#ef4444'
};
export function PaymentItem({
  payment,
  onUploadProof,
  onPayNow
}: PaymentItemProps) {
  const Icon = statusIcons[payment.status];
  const iconColor = statusColors[payment.status];
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 0
    }).format(amount);
  };
  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  return <Box p="md" style={{
    backgroundColor: '#ffffff',
    borderRadius: 12,
    border: `1px solid ${payment.status === 'overdue' ? '#fecaca' : '#e2e8f0'}`,
    borderLeft: `4px solid ${iconColor}`
  }} data-id="element-53">
      <Stack gap="sm" data-id="element-54">
        <Group justify="space-between" align="flex-start" data-id="element-55">
          <Group gap="sm" wrap="nowrap" data-id="element-56">
            <Box p={8} style={{
            backgroundColor: payment.status === 'paid' ? '#d1fae5' : payment.status === 'overdue' ? '#fee2e2' : '#f1f5f9',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }} data-id="element-57">
              <Icon size={18} color={iconColor} data-id="element-58" />
            </Box>
            <Stack gap={2} data-id="element-59">
              <Text fw={600} size="sm" c="#1a2332" data-id="element-60">
                {payment.description}
              </Text>
              <Text size="xs" c="#64748b" data-id="element-61">
                Due: {formatDate(payment.dueDate)}
                {payment.paidDate && ` • Paid: ${formatDate(payment.paidDate)}`}
              </Text>
            </Stack>
          </Group>
          <StatusBadge status={payment.status} data-id="element-62" />
        </Group>

        <Group justify="space-between" align="center" data-id="element-63">
          <Text fw={700} size="lg" c="#1a2332" data-id="element-64">
            {formatCurrency(payment.amount)}
          </Text>
          {payment.status !== 'paid' && <Group gap="xs" data-id="element-65">
              <Button variant="filled" color="green" size="xs" radius="md" leftSection={<CreditCard size={14} data-id="element-67" />} onClick={onPayNow} styles={{
            root: {
              backgroundColor: '#10b981',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: '#059669',
                transform: 'translateY(-1px)',
                boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)'
              }
            }
          }} data-id="element-66">
                Pay Now
              </Button>
              <Button variant="light" color="gray" size="xs" radius="md" leftSection={<Upload size={14} data-id="element-69" />} onClick={onUploadProof} styles={{
            root: {
              transition: 'all 0.2s ease',
              '&:hover': {
                transform: 'translateY(-1px)',
                boxShadow: '0 2px 8px rgba(100, 116, 139, 0.2)'
              }
            }
          }} data-id="element-68">
                Upload Proof
              </Button>
            </Group>}
        </Group>
      </Stack>
    </Box>;
}